export default __webpack_public_path__ + "static/media/04.9cd12175.jpg";